import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '..\\layouts\\error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_03acb728 from 'nuxt_plugin_plugin_03acb728' // Source: .\\components\\plugin.js (mode: 'all')
import nuxt_plugin_nuxtleaflet_6ffd0756 from 'nuxt_plugin_nuxtleaflet_6ffd0756' // Source: .\\nuxt-leaflet.js (mode: 'client')
import nuxt_plugin_toast_77f3a73e from 'nuxt_plugin_toast_77f3a73e' // Source: .\\toast.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_01abfc37 from 'nuxt_plugin_cookieuniversalnuxt_01abfc37' // Source: .\\cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_axios_a8794ae2 from 'nuxt_plugin_axios_a8794ae2' // Source: .\\axios.js (mode: 'all')
import nuxt_plugin_api_5e4622e4 from 'nuxt_plugin_api_5e4622e4' // Source: ..\\plugins\\api (mode: 'all')
import nuxt_plugin_repositories_3f2ec844 from 'nuxt_plugin_repositories_3f2ec844' // Source: ..\\plugins\\repositories (mode: 'all')
import nuxt_plugin_veevalidate_1a0c1998 from 'nuxt_plugin_veevalidate_1a0c1998' // Source: ..\\plugins\\vee-validate.js (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ..\\plugins\\axios (mode: 'all')
import nuxt_plugin_i18n_3032693c from 'nuxt_plugin_i18n_3032693c' // Source: ..\\plugins\\i18n.js (mode: 'all')
import nuxt_plugin_utils_3efabacd from 'nuxt_plugin_utils_3efabacd' // Source: ..\\plugins\\mixins\\utils.js (mode: 'all')
import nuxt_plugin_directiveCloseAble_2d54ad04 from 'nuxt_plugin_directiveCloseAble_2d54ad04' // Source: ..\\plugins\\directiveCloseAble.js (mode: 'all')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ..\\plugins\\element-ui (mode: 'all')
import nuxt_plugin_vuecarousel3d_e42043be from 'nuxt_plugin_vuecarousel3d_e42043be' // Source: ..\\plugins\\vue-carousel-3d (mode: 'client')
import nuxt_plugin_vue2perfectscrollbar_ddf3318e from 'nuxt_plugin_vue2perfectscrollbar_ddf3318e' // Source: ..\\plugins\\vue2-perfect-scrollbar (mode: 'all')
import nuxt_plugin_ckeditor_521dc1c9 from 'nuxt_plugin_ckeditor_521dc1c9' // Source: ..\\plugins\\ckeditor (mode: 'all')
import nuxt_plugin_vuepdf_e5d1a892 from 'nuxt_plugin_vuepdf_e5d1a892' // Source: ..\\plugins\\vue-pdf (mode: 'all')
import nuxt_plugin_plugin_8fba3a04 from 'nuxt_plugin_plugin_8fba3a04' // Source: .\\auth\\plugin.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Cổng thông tin xúc tiến đầu tư - Tỉnh Quảng Nam","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Cổng thông tin xúc tiến đầu tư tỉnh Quảng Nam"},{"name":"format-detection","content":"telephone=no"},{"hid":"og:title","property":"og:title","content":"Cổng thông tin xúc tiến đầu tư tỉnh Quảng Nam"},{"hid":"og:description","property":"og:description","content":"Cổng thông tin xúc tiến đầu tư tỉnh Quảng Nam"},{"hid":"og:keywords","property":"og:keywords","name":"keywords","content":"đầu tư quảng nam, đầu tư vào quảng nam, dau tu quang nam, dau tu vao quang nam, dau tu, quang nam, Cổng thông tin, thông tin, xúc tiến đầu tư, đầu tư, Quảng Nam"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:image","property":"og:image","content":"https:\u002F\u002Fdautu-quangnam-api.e-gov.com.vn\u002Fdata\u002Fxtdtfiles\u002Fthuvienanhvideo\u002Fog-image-1662604885348.jpg"},{"hid":"og:image:alt","property":"og:image:alt","content":"Cổng thông tin xúc tiến đầu tư tỉnh Quảng Nam"},{"hid":"og:url","property":"og:url","content":"https:\u002F\u002Fdautu.quangnam.gov.vn\u002F"},{"hid":"og:locale","property":"og:locale","content":"vi_VN"},{"hid":"og:locale:alternate","property":"og:locale:alternate","content":"en_US"}],"cript":[{"src":"\u002Fjquery-3.5.1.slim.min.js"},{"src":"\u002Fpopper.min.js"},{"src":"\u002Fbootstrap.min.js"}],"link":[{"rel":"icon","type":"image","href":"\u002Fimages\u002Ffavicon.ico"},{"rel":"apple-touch-icon","href":"\u002Fimages\u002Ftouch-icon-iphone.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"\u002Fimages\u002Ftouch-icon-iphone.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"\u002Fimages\u002Ftouch-icon-iphone-retina.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"\u002Fimages\u002Ftouch-icon-ipad-retina.png"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Great Vibes"},{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Montserrat"},{"rel":"stylesheet","href":"https:\u002F\u002Fwww.fontzip.com\u002Fstorage\u002F2019\u002F02\u002F19\u002Futm-nokia\u002Fwebfonts\u002FUTM Nokia.css"},{"rel":"stylesheet","href":"\u002Fbootstrap.min.css"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_03acb728 === 'function') {
    await nuxt_plugin_plugin_03acb728(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_nuxtleaflet_6ffd0756 === 'function') {
    await nuxt_plugin_nuxtleaflet_6ffd0756(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_77f3a73e === 'function') {
    await nuxt_plugin_toast_77f3a73e(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_01abfc37 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_01abfc37(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_a8794ae2 === 'function') {
    await nuxt_plugin_axios_a8794ae2(app.context, inject)
  }

  if (typeof nuxt_plugin_api_5e4622e4 === 'function') {
    await nuxt_plugin_api_5e4622e4(app.context, inject)
  }

  if (typeof nuxt_plugin_repositories_3f2ec844 === 'function') {
    await nuxt_plugin_repositories_3f2ec844(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_1a0c1998 === 'function') {
    await nuxt_plugin_veevalidate_1a0c1998(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_3032693c === 'function') {
    await nuxt_plugin_i18n_3032693c(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_3efabacd === 'function') {
    await nuxt_plugin_utils_3efabacd(app.context, inject)
  }

  if (typeof nuxt_plugin_directiveCloseAble_2d54ad04 === 'function') {
    await nuxt_plugin_directiveCloseAble_2d54ad04(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel3d_e42043be === 'function') {
    await nuxt_plugin_vuecarousel3d_e42043be(app.context, inject)
  }

  if (typeof nuxt_plugin_vue2perfectscrollbar_ddf3318e === 'function') {
    await nuxt_plugin_vue2perfectscrollbar_ddf3318e(app.context, inject)
  }

  if (typeof nuxt_plugin_ckeditor_521dc1c9 === 'function') {
    await nuxt_plugin_ckeditor_521dc1c9(app.context, inject)
  }

  if (typeof nuxt_plugin_vuepdf_e5d1a892 === 'function') {
    await nuxt_plugin_vuepdf_e5d1a892(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_8fba3a04 === 'function') {
    await nuxt_plugin_plugin_8fba3a04(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
